import { render, staticRenderFns } from "./RoleSelector.vue?vue&type=template&id=1d32de0e&scoped=true&"
import script from "./RoleSelector.vue?vue&type=script&lang=js&"
export * from "./RoleSelector.vue?vue&type=script&lang=js&"
import style0 from "./RoleSelector.vue?vue&type=style&index=0&id=1d32de0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d32de0e",
  null
  
)

export default component.exports